import { HistoryMovement } from 'types';
import { CustomRange } from '../types/CustomRange';

type GetHistoryMovementsProps = {
  reassignedRanges: CustomRange[];
  holdingClassName?: string;
};

export const getHistoryMovements = ({
  reassignedRanges,
  holdingClassName = '',
}: GetHistoryMovementsProps): HistoryMovement[] => {
  const historyMovements = reassignedRanges.map((range: CustomRange) => ({
    from: range.from,
    to: range.to,
    holdingClassName,
    newFrom: range.newFrom,
    newTo: range.newTo,
    newHoldingClassName: holdingClassName,
  }));

  return historyMovements;
};
